import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { flex } from '../../../../utils/flex.vanilla.mjs';
import { definitionListItem } from './definitionListItem.vanilla.mjs';

const TooltipDefinitionListItem = forwardRef(
  ({
    align = "center",
    className: classNameFromProps,
    direction,
    justify,
    ...props
  }, forwardedRef) => {
    const className = classNames(
      definitionListItem,
      flex({ align, direction, justify }),
      classNameFromProps
    );
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-scope": "tooltip",
        "data-part": "definition-list-item",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
TooltipDefinitionListItem.displayName = "Tooltip.DefinitionListItem";

export { TooltipDefinitionListItem };
//# sourceMappingURL=DefinitionListItem.mjs.map
